// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles__wrapper___25TqM","message":"styles__message___2y2Fk"};